import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import request from "helper/request";
import "./PoolTracking.scss";

const trackingSteps = [
  "submitted",
  "at_warehouse",
  "pickup_completed",
  "dropoff_in_progress",
  "dropoff_completed"
];

export default function PoolTracking() {
  const { token } = useParams();
  const [packageDetails, setPackageDetails] = useState({});

  useEffect(() => {
    const fetchPackageDetails = async () => {
      try {
        const response = await request.get(
          `${window.REACT_APP_API_ENDPOINT}/public/pool/full-tracking/package/${token}`
        );
        setPackageDetails(response);
      } catch (error) {
        console.error("Error fetching package:", error);
      }
    };
    fetchPackageDetails();
  }, [token]);

  const getAdjustedETA = (date) => {
    let eta = moment(date).add(1, "days");
    if (eta.day() === 0) eta = eta.add(1, "days");
    return eta.format("dddd, YYYY-MM-DD");
  };

  const currentStepIndex = trackingSteps.indexOf(packageDetails.status);

  return (
    <div className="tracking-container">
      <h2 className="tracking-title">Package Tracking</h2>

      <p className="tracking-info">
        <strong>Order ID:</strong> {packageDetails?.orderV2_id}
      </p>
      <p className="tracking-info">
        <strong>Package ID:</strong> {packageDetails?.id}
      </p>
      <p className="tracking-info">
        <strong>Barcode:</strong> {packageDetails?.barcode}
      </p>
      <p className="tracking-info">
        <strong>Dropoff Address:</strong> {packageDetails?.dropoffAddress}
      </p>

      <div className="tracking-status">
        <Status packageDetails={packageDetails} />
      </div>

      <p className="tracking-eta">ETA: {getAdjustedETA(packageDetails?.pickupDate)}</p>

      <div className="progress-container">
        <p className="progress-label">Delivery Progress</p>
        <div className="progress-bar">
          {trackingSteps.map((step, idx) => (
            <div
              key={step}
              className={`progress-step ${idx <= currentStepIndex ? "active" : ""}`}
              title={step.replace(/_/g, " ")}
            >
              {idx + 1}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function Status({ packageDetails }) {
  switch (packageDetails.status) {
    case "submitted":
      return "Submitted. Package has been uploaded to Flexio.";
    case "pending":
      return "Pending. Package has been acknowledged by Flexio.";
    case "at_warehouse":
      return "At the warehouse. Package is ready for delivery.";
    case "pickup_scheduled":
      return "Pickup scheduled. Driver will collect the package soon.";
    case "pickup_in_progress":
      return "Pickup in progress. Driver is en route.";
    case "pickup_completed":
      return "Pickup completed. Package is in transit.";
    case "dropoff_in_progress":
      return "Dropoff in progress. Delivery is on the way.";
    case "dropoff_completed":
      return "Delivered successfully.";
    case "dropoff_failed":
      return "Dropoff failed. Please contact support.";
    case "cancelled":
      return "Package has been cancelled.";
    default:
      return "Tracking status is updating.";
  }
}
